





































import { Component, Vue, Prop } from 'vue-property-decorator';

import { curApiService, ApiService } from '@/services/ApiService';

import moment from 'moment';
import tippy from 'tippy.js';
import { FullAlert } from '@/types';

@Component({
  components:{

  }
})
export default class AlertRowMobile extends Vue {

  @Prop({ default: {},  type: Object}) alert!: FullAlert;
  @Prop({ default: 0,  type: Number}) index!: number;
  @Prop({ default: false,  type: Boolean}) disabled!: boolean;
  
  error:string = '';

  curSection:'info'|'connection'|'healthTraffic'|'backhauls'|'location' = 'info';

    
  async mounted() {
    tippy('[data-tippy-content]');
  }

  formatTs(ts:number|undefined): {time: string, ago: string} {

    return {
      time: ts ? moment(ts).format('L LT') : 'N/A',
      ago: ts ? moment(ts).fromNow() : 'N/A'
    };
  }

  formatName(name:string): string {
    if(name.length <= 30)
      return name;
    return name.substring(0, 27) + '...';
  }

  
  lrrRefClicked(lrrRef:string) {
    this.$router.push({name:'base-stations', params:{searchTerm:lrrRef}})
  }

  clearAlert(alertId:string) {
    this.$emit('clear-alert', alertId);
  }

}

